document.addEventListener('DOMContentLoaded', function () {

    var section = document.querySelector('.testimonials');

    if (!section) return;

    var track = document.getElementById('testimonialsTrack');
    var cards = Array.prototype.slice.call(
        track.querySelectorAll('.testimonial-card')
    );
    var dotsWrap = document.getElementById('testimonialsDots');
    var prevBtn = document.getElementById('testimonialsPrev');
    var nextBtn = document.getElementById('testimonialsNext');
    var header = section.querySelector('.testimonials__header');


    /* Card step */

    function getCardStep() {

        if (!cards[0]) return 0;

        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 24);

        return cards[0].getBoundingClientRect().width + gap;
    }


    /* Number of visible cards */

    function getVisibleCards() {

        if (!cards[0]) return 1;

        var cardWidth = cards[0].getBoundingClientRect().width;
        var step = getCardStep();

        return Math.max(
            1,
            Math.floor((track.clientWidth + (step - cardWidth)) / step)
        );
    }


    /* Build dots */

    function buildDots() {

        dotsWrap.innerHTML = '';

        var visibleCards = getVisibleCards();
        var dotCount = Math.max(
            1,
            cards.length - visibleCards + 1
        );

        for (var i = 0; i < dotCount; i++) {

            var dot = document.createElement('button');

            dot.type = 'button';
            dot.className = 'testimonials__dot';
            dot.setAttribute(
                'aria-label',
                'Go to testimonial ' + (i + 1)
            );

            dot.addEventListener('click', function (index) {

                return function () {
                    scrollToCard(index);
                };

            }(i));

            dotsWrap.appendChild(dot);
        }
    }


    /* Get active position */

    function getActiveIndex() {

        var step = getCardStep();

        if (!step) return 0;

        return Math.round(track.scrollLeft / step);
    }


    /* Update active dot + arrows */

    function updateActiveState() {

        var index = getActiveIndex();

        var dots = Array.prototype.slice.call(
            dotsWrap.querySelectorAll('.testimonials__dot')
        );

        dots.forEach(function (dot, i) {

            dot.classList.toggle(
                'is-active',
                i === index
            );

        });

        prevBtn.disabled = track.scrollLeft <= 4;

        nextBtn.disabled =
            track.scrollLeft >=
            track.scrollWidth - track.clientWidth - 4;
    }


    /* Scroll to card */

    function scrollToCard(index) {

        var step = getCardStep();

        track.scrollTo({
            left: step * index,
            behavior: 'smooth'
        });
    }


    /* Previous */

    prevBtn.addEventListener('click', function () {

        scrollToCard(
            Math.max(getActiveIndex() - 1, 0)
        );

    });


    /* Next */

    nextBtn.addEventListener('click', function () {

        var visibleCards = getVisibleCards();

        var maxIndex = Math.max(
            cards.length - visibleCards,
            0
        );

        scrollToCard(
            Math.min(
                getActiveIndex() + 1,
                maxIndex
            )
        );

    });


    /* Scroll */

    var scrollTimeout;

    track.addEventListener('scroll', function () {

        window.clearTimeout(scrollTimeout);

        scrollTimeout = window.setTimeout(
            updateActiveState,
            80
        );

    });


    /* Resize */

    window.addEventListener('resize', function () {

        buildDots();
        updateActiveState();

    });


    /* Entrance animations */

    if ('IntersectionObserver' in window) {

        var headerObserver = new IntersectionObserver(
            function (entries, obs) {

                entries.forEach(function (entry) {

                    if (entry.isIntersecting) {

                        entry.target.classList.add('is-visible');

                        obs.unobserve(entry.target);

                    }

                });

            },
            { threshold: 0.2 }
        );

        if (header) {
            headerObserver.observe(header);
        }


        var cardObserver = new IntersectionObserver(
            function (entries, obs) {

                entries.forEach(function (entry) {

                    if (entry.isIntersecting) {

                        var delay =
                            Array.prototype.indexOf.call(
                                cards,
                                entry.target
                            ) * 90;

                        window.setTimeout(function () {

                            entry.target.classList.add('is-visible');

                        }, delay);

                        obs.unobserve(entry.target);

                    }

                });

            },
            { threshold: 0.15 }
        );


        cards.forEach(function (card) {

            cardObserver.observe(card);

        });

    } else {

        if (header) {
            header.classList.add('is-visible');
        }

        cards.forEach(function (card) {

            card.classList.add('is-visible');

        });

    }


    /* Initialize */

    buildDots();
    updateActiveState();

});